import { useState } from "react";
import { useAuthenticationService } from "../../../../services/authentication.service";
import roles from "../../../../utils/constants/roles";
import { Input } from "rsuite";
import { Button } from "../../../../components";
import { FaSearch } from "react-icons/fa";

export default function ExpandedRowActions({ displayData, searchTerm, setSearchTerm, onCreate, onReprocess, onShowPdf, pdfAvailable }) {
  const AuthenticationService = useAuthenticationService();
  const isAdmin = AuthenticationService.isInAnyRole(roles.ADMINS);
  return (
    <div className="entries-actions" data-testid="expanded-row-actions">
      {displayData.length > 0 && (
        <Input
          label="Search"
          value={searchTerm}
          onChange={(value) => setSearchTerm(value || "")}
          placeholder="Search..."
          style={{ marginRight: 8, width: 400 }}
          icon={<FaSearch />}
        />
      )}
      <Button
        appearance="primary"
        size="sm"
        text="Create Entry"
        data-testid="create-entry-button"
        className="create-entry-button"
        onClick={onCreate}
        disabled={!isAdmin}
      />
      {displayData.length > 0 && (
        <Button appearance="primary" size="sm" text="Reprocess" data-testid="reprocess-button" className="reprocess-button" onClick={onReprocess} disabled={!isAdmin} />
      )}
      {pdfAvailable && <Button onClick={onShowPdf} appearance="primary" size="sm" text="Pdf" className="pdf-button" data-testid="pdf-button" />}
    </div>
  );
}
